import { useCommonStore } from './common'
import { useIspInstallStore } from './ispInstall'
import { useLoadingStore } from './loading'

const store = createPinia()

export { useCommonStore, useIspInstallStore, useLoadingStore }

export default store
